//HEAD 
window["gdpr-cookie-notice-templates"] = {};

window["gdpr-cookie-notice-templates"]["bar.html"] = "<div class=\"gdpr-cookie-notice\">\n" +
    "  <div class=\"gdpr-cookie-notice-content\">\n" +
    "    <p class=\"gdpr-cookie-notice-title\">{bar_title}</p>\n" +
    "    <p class=\"gdpr-cookie-notice-description\">\n" +
    "      {description}\n" +
    "      <span class=\"gdpr-cookie-notice-link\">\n" +
    "        <a class=\"gdpr-cookie-notice-policy-link\" target=\"_blank\">{policy}</a>\n" +
    "        <span class=\"gdpr-cookie-notice-divider-link\"></span>\n" +
    "        <a class=\"gdpr-cookie-notice-manage\" target=\"_blank\">{manage}</a>\n" +
    "      </span>\n" +
    "    </p>\n" +
    "  </div>\n" +
    "  <nav class=\"gdpr-cookie-notice-nav\">\n" +
    "    <button\n" +
    "      href=\"#\"\n" +
    "      class=\"gdpr-cookie-notice-nav-item gdpr-cookie-notice-nav-item-accept gdpr-cookie-notice-nav-item-btn\"\n" +
    "    >\n" +
    "      <span class=\"gdpr-cookie-notice-nav-item-btn-text\">{accept}</span>\n" +
    "      <span class=\"gdpr-cookie-notice-nav-item-btn-overlay\"></span>\n" +
    "    </button>\n" +
    "  </nav>\n" +
    "</div>\n" +
    ""; 

window["gdpr-cookie-notice-templates"]["category.html"] = "<li class=\"gdpr-cookie-notice-modal-cookie\">\n" +
    "  <div\n" +
    "    class=\"gdpr-cookie-notice-modal-cookie-row gdpr-cookie-notice-modal-cookie-row-{prefix}\"\n" +
    "  >\n" +
    "    <h3 class=\"gdpr-cookie-notice-modal-cookie-title\">{title}</h3>\n" +
    "    <input\n" +
    "      type=\"checkbox\"\n" +
    "      name=\"gdpr-cookie-notice-{prefix}\"\n" +
    "      checked=\"checked\"\n" +
    "      id=\"gdpr-cookie-notice-{prefix}\"\n" +
    "      class=\"gdpr-cookie-notice-modal-cookie-input\"\n" +
    "    />\n" +
    "    <label\n" +
    "      class=\"gdpr-cookie-notice-modal-cookie-input-switch\"\n" +
    "      for=\"gdpr-cookie-notice-{prefix}\"\n" +
    "    ></label>\n" +
    "  </div>\n" +
    "  <p class=\"gdpr-cookie-notice-modal-cookie-info\">{desc}</p>\n" +
    "</li>\n" +
    ""; 

window["gdpr-cookie-notice-templates"]["modal.html"] = "<div class=\"gdpr-cookie-notice-modal\">\n" +
    "  <div class=\"gdpr-cookie-notice-modal-content\">\n" +
    "    <div class=\"gdpr-cookie-notice-modal-header\">\n" +
    "      <h2 class=\"gdpr-cookie-notice-modal-title\">{settings}</h2>\n" +
    "      <button type=\"button\" class=\"gdpr-cookie-notice-modal-close\"></button>\n" +
    "    </div>\n" +
    "    <ul class=\"gdpr-cookie-notice-modal-cookies\"></ul>\n" +
    "    <div class=\"gdpr-cookie-notice-modal-footer\">\n" +
    "      <a\n" +
    "        href=\"#\"\n" +
    "        class=\"gdpr-cookie-notice-modal-footer-item gdpr-cookie-notice-modal-footer-item-save gdpr-cookie-notice-modal-footer-item-btn\"\n" +
    "        ><span>{save}</span></a\n" +
    "      >\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    ""; 

window["gdpr-cookie-notice-templates"]["toggle-button.html"] = "<div class=\"gdpr-cookie-notice-toggle-button\">\n" +
    "  <button>{toggle_button_first}<span>{toggle_button_second}</span></button>\n" +
    "</div>\n" +
    ""; 
// END 